import { QRFC } from "./QRFC";

export class QGetExcelDataRFC extends QRFC {
  constructor() {
    super();
    this.fFileName = null;
    this.fDirectory = null;
    this.fOptions = 0;
  }

  InitGetExcelDataRFC(callbackObj, fileName, directory, limit) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.fFileName = fileName;
    this.fDirectory = directory;
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qgetexceldata";
  }

  SetOptions(options) {
    this.fOptions = options;
  }

  SetParams(org, user, fileName, directory, limit) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("target", fileName);
    this.AddEncodedParameter("directory", directory);
    this.AddParameter("options", this.fOptions);

    if (limit != null) var limit = JSON.stringify(limit);
    this.AddEncodedParameter("limit", limit);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var success = true;
    if (r == "failure") success = false;

    callBackObj.GetExcelDataResult(success, r, this.fFileName, this.fDirectory);
  }
}
